import { OutletType } from "admin/src/types";
import React from "react";
import TableDetail from "../../../shared/Table/TableDetail";
import { IUser } from "../../../types/userType";

const defaultProps = {
	datas: [
		{
			displayName: "Sewa Aku",
			fullName: "Emilia",
			description: "mantap",
			birthday: "2021-12-09T13:32:25.387Z",
			gender: "Male",
			phone: "8881234442",
			avatar: "/avatar.png",
			createdAt: "2021-12-09T13:57:37.604Z",
			updatedAt: "2021-12-09T14:40:19.041Z",
		},
	],
};

const InformationTable = ({ context }: OutletType<IUser>): JSX.Element => {
	// eslint-disable-next-line
	return (
		<div className=" border-gray-200">
			<dl>
				{context.profile &&
					Object.entries(context.profile).map(([key, value], index) => {
						return (
							<TableDetail
								key={index}
								property={key}
								value={value}
								index={index}
							/>
						);
					})}
			</dl>
		</div>
	);
};

InformationTable.defaultProps = defaultProps;

export default InformationTable;
